<!-- ----------------------------------------------- -->
<template>
  <div class="legend-content">
    <v-container style="align-items:center">
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.stgDanger" style="height: 27px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.stgDanger }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.stgRefuge" style="height: 27px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.stgRefuge }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.stgWarn" style="height: 27px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.stgWarn }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.stgFldctl" style="height: 27px;" />
        </v-col>
        <v-col :cols="9">
          <span class="location-text pl-2">
            {{ text.stgFldctl }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.stgNormal" style="height: 27px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.stgNormal }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.stgNotset" style="height: 27px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.stgNotset }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.stgMissing" style="height: 27px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.stgMissing }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters pt-1">
        <v-col :cols="1" class="location-img pl-10">
          <img :src="imgResource.upMark" style="height: 21px;" />
        </v-col>
        <v-col :cols="4">
          <span class="location-text pl-1">
            {{ text.upMark }}
          </span>
        </v-col>
        <v-col :cols="1" class="location-img">
          <img :src="imgResource.normalMark" style="height: 21px;" />
        </v-col>
        <v-col :cols="4">
          <span class="location-text pl-1">
            {{ text.normalMark }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters pt-1">
        <v-col :cols="1" class="location-img pl-10">
          <img :src="imgResource.downMark" style="height: 21px;" />
        </v-col>
        <v-col :cols="4">
          <span class="location-text pl-1">
            {{ text.downMark }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>

/**
 * 川の防災情報 地図画面 地図凡例ダイアログ 通常水位
 * LegendTmStg.vue
 * @author LIS
 */
export default {
  name: "legend-tm-stg",
  data() {
    return {
      /** アイコン */
      imgResource: {
        stgDanger: "/kawabou/img/map_icons/obs_water_danger.svg",
        stgRefuge: "/kawabou/img/map_icons/obs_water_refuge.svg",
        stgWarn: "/kawabou/img/map_icons/obs_water_caution.svg",
        stgFldctl: "/kawabou/img/map_icons/obs_water_fldctl.svg",
        stgNormal: "/kawabou/img/map_icons/obs_water_normal.svg",
        stgNotset: "/kawabou/img/map_icons/obs_water_notset.svg",
        stgMissing: "/kawabou/img/map_icons/obs_water_missing.svg",
        upMark: "/kawabou/img/map_icons/obs_water_up_mark.svg",
        downMark: "/kawabou/img/map_icons/obs_water_down_mark.svg",
        normalMark: "/kawabou/img/map_icons/obs_water_normal_mark.svg",
      },
      /** 文字列リソース */
      text: {
        stgDanger: "氾濫危険水位超過",
        stgRefuge: "避難判断水位超過",
        stgWarn: "氾濫注意水位超過",
        stgFldctl: "水防団待機水位超過",
        stgNormal: "平常",
        stgNotset: "基準水位なし",
        stgMissing: "欠測",
        upMark: "上昇中",
        downMark: "下降中",
        normalMark: "変化なし",
      },
    };
  },
  computed: {
    /**
     * 水位表示モードの取得
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.legend-content {
  width: 220px;
  .location-img {
    display: flex;
    justify-content: flex-end;
    position: relative;
    .badge {
      // position: absolute;
      top: -3px;
      right: 0px;
    }
  }
  .location-text {
    font-size: 0.9rem;
    color: black;
  }
}
</style>